export const LastUpdated = '8 Mai 2026';
